import React, { useState } from 'react';
import Title from 'components/UI/Title';
import QuotesSummary from 'components/BusinessLogic/Quotes/QuotesSummary/Loadable';
import QuotesFilters from 'components/BusinessLogic/Quotes/QuotesFilters';
import ContactUs from 'components/UI/ContactUs';
import { useParams, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

function Requests({ isB2cPage })
{
    const navigate = useNavigate();
    const { page } = useParams();
    const [filters, setFilters] = useState({
        checkinAfter: null,
        checkinBefore: null,
        quoteDateAfter: null,
        bookingHotel: null,
    });

    const onFiltersUpdate = (result) =>
    {
        navigate('/requests/1');
        setFilters({ ...filters, ...result });
    };

    return (
        <div className="tw-flex tw-flex-col tw-flex-1 tw-w-full h-full tw-overflow-y-auto tw-p-10  lg:tw-pl-[248px]">
            <div className="tw-flex tw-justify-between tw-items-start tw-gap-3">
                <div className="tw-flex tw-flex-col">
                    <Title
                        title="Quotes"
                    />
                    <QuotesFilters
                        onFiltersUpdate={(tabFilters) => onFiltersUpdate(tabFilters)}
                    />
                </div>

                <div className="tw-max-w-fit">
                    <ContactUs isB2cPage={isB2cPage} />
                </div>

            </div>

            <QuotesSummary
                isB2cPage={isB2cPage}
                page={parseInt(page, 10) ?? 1}
                checkinAfter={filters.checkinAfter}
                checkinBefore={filters.checkinAfter}
                quoteDateAfter={filters.quoteDateAfter}
                bookingHotel={filters.bookingHotel}
            />

            <Helmet title={`Requests | ${isB2cPage ? 'Luxuria Vacations' : 'UJV'}`}>
                <meta name="description" content="Requests" />
            </Helmet>

        </div>
    );
}

Requests.defaultProps = {
    isB2cPage: false,
};

Requests.propTypes = {
    isB2cPage: PropTypes.bool,
};

export default Requests;
